/// <summary name='cafm.costs'>Container object for CAFM Costs code</summary>
cafm.costs = {
    listSelector: '#costLv',
    changedHandlerName: 'cafm.costs.onCostsChanged',
    init: function () {
        /// <summary>Costs initialiser</summary>

        $('[name=QuotationCostIsAbsolute]').off('change.cafm').on('change.cafm', function () {

            cafm.util.callFunctionAsync({
                func: function () {
                    $('#quotationMarginMisc,#quotationMarginParts').find('[data-bind]').enableNumeric(!cafm.hd.workOrder.QuotationCostIsAbsolute);
                },
                timeout: 100
            })
        });
    },
    onBcpLookupFetch: function (criteria) {
        /// <summary>Asset lookup pre fetch handler</summary>
        /// <param name="criteria" type="Object">Criteria to be sent with request</param>

        if (criteria.BCPType && criteria.BCPType.value) {
            criteria.set('BCPType', criteria.BCPType.value);
        }

        if (criteria.Status && criteria.Status.value) {
            criteria.set('Status', criteria.Status.value);
        }
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when cost list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of cost data</param>

        cafm.util.convertAllUTCToSessionDateTimes(d, ['CreatedDate']);
    },
    validate: function () {
        /// <summary>Cost custom validation function</summary>

        var v = this.get('values');
        var valid = v.get('EstimatedCost') || v.get('ActualCost');
        this.set('valid', valid);
        if (!valid) {
            this.set('validationMessage', cafm.res.str.MessageCostAmountRequired);
            this.set('preValidate', function (a) {
                a.set('validationMessage', cafm.res.str.MessageCostInvalid);
            });
        }
    },
    editToolbar: {
        add: function (e) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddMiscellaneousCost'),
                values: $('#actionFormPlc').getViewModel(),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                validate: cafm.costs.validate,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.costs.changedHandlerName, r);
                        cafm.costs.refreshList();
                        $('#costsPlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageCostAdded });
                        cafm.hd.actions.closeActionWindow();
                    }
                },
                validationMessage: cafm.res.str.MessageCostInvalid
            });
        },
        update: function (e) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/UpdateMiscellaneousCost'),
                values: $('#actionFormPlc').getViewModel(),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                validate: cafm.costs.validate,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.costs.changedHandlerName, r);
                        cafm.costs.refreshList();
                        $('#costsPlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageCostUpdated });
                        cafm.hd.actions.closeActionWindow();
                    }
                },
                validationMessage: cafm.res.str.MessageCostInvalid
            });
        },
        cancel: function (e) {
            /// <summary>Handler for when cancelling out of cost creation or edits</summary>
            /// <param name="e" type="Object">DOM event</param>

            cafm.hd.actions.closeActionWindow();
        }
    },
    listToolbar: {
        add: function(){

            var vm = {
                submit: cafm.costs.editToolbar.add,
                cancel: cafm.costs.editToolbar.cancel,
                WorkOrderID: cafm.hd.workOrder.ID
            };
            cafm.costs.prepareFormViewModel(vm);
            cafm.views.openActionWindow({
                url: cafm.url.get('Costs/NewCost'),
                isForm: true,
                viewModel: vm,
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleAddCost,
                    width: cafm.util.viewPortWidth(40),
                    height: cafm.views.actionWindowConfig.medium.height()
                }
            });
        },
        edit: function (e) {
            /// <summary>Edit handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            if (!$('#editCost').length && costs.permissions && costs.permissions.edit) {

                var editBtn = $(e.target);
                var editTarget = editBtn.data('editTarget');
                var lv = editBtn.getLvFromTb();
                var id = editTarget.data('id');

                if (!id) {

                    $('#costsPlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoCostSelected });
                    return;
                }
                else {

                    $('#costsPlc').hideMessage();
                }

                var vm = cafm.util.clone(lv.element.getListViewDataItem(id, 'CostID'));
                vm.WorkOrderID = cafm.hd.workOrder.get('ID');
                vm.submit = cafm.costs.editToolbar.update;
                vm.cancel = cafm.costs.editToolbar.cancel;

                cafm.costs.prepareFormViewModel(vm);

                cafm.views.openActionWindow({
                    url: cafm.url.get('Costs/EditCost'),
                    isForm: true,
                    viewModel: vm,
                    initialText: cafm.res.str.TextPreparingForm,
                    winOptions: {
                        title: cafm.res.str.TitleEditCost,
                        width: cafm.util.viewPortWidth(40),
                        height: 320
                    }
                });
            }
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var selIds = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'CostID' });
            if (!selIds) {
                $('#costsPlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoCostSelected });
                return;
            }

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/RemoveMiscellaneousCosts'),
                description: cafm.res.str.TextDeleteCost,
                values: selIds,
                elementId: 'costsPlc',
                loaderSelector: '#costsPlc',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.costs.changedHandlerName, r);
                        cafm.costs.refreshList();
                        $('#costsPlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                    }
                }
            });
        }
    },
    refreshList: function () {

        cafm.util.refreshList({
            listSelector: cafm.costs.listSelector,
            key: cafm.res.consts.DataKey_HelpdeskCosts
        });
    },
    enablePermissibleFeatures: function (p) {
        
        var clv = $('#costLv'),
            lh = clv.find('.cLvHead');

        if (p.add || p.remove) {

            lh.show();

            if (p.add) {

                $('[data-key="Add"]', lh).show();
            }
        }
        
        if (!p.add) {

            $('[data-key="Add"]', lh).remove();
        }

        if (!p.remove) {

            clv.disableListItemRemoving();
        }

        if (p.edit) {

            $('#chargeToLookup').enableLookup();

            $('#estimateLabourCharge').find('[data-bind]').enableNumeric(true);

            if (cafm.hd.workOrder.IsQuotationWorkOrderEnabled) {

                $('#quotationMarginLabour').find('[data-bind]').enableNumeric(true);
                $('#quotationCostIsAbsolute,#applyQuotationMarginOnEstimated').setCheckboxDisabled(false);

                if (!cafm.hd.workOrder.QuotationCostIsAbsolute) {

                    $('#quotationMarginMisc,#quotationMarginParts').find('[data-bind]').enableNumeric(true);
                }
            }

        }
        else {

            clv.disableListItemEditing();
        }

        costs.permissions = p;
    },
    getWorkOrderCosts: function () {

        return cafm.hd.getWorkOrderChildList('Costs');
    },
    initForm: function () {
        
        if (cafm.hd.workOrder.IsQuotationWorkOrderEnabled)
            $('#quotationCost [data-bind]').prop('disabled', !cafm.hd.workOrder.QuotationCostIsAbsolute);
    },
    prepareFormViewModel: function (vm) {

        vm.HasAccessToActualCosts = cafm.hd.workOrder.HasAccessToActualCosts;
        vm.HasAccessToEstimatedCosts = cafm.hd.workOrder.HasAccessToEstimatedCosts;
        vm.IsQuotationWorkOrderEnabled = cafm.hd.workOrder.IsQuotationWorkOrderEnabled;
    }
}
window.costs = cafm.costs;